import { useState } from "react"
import { TooltipButton } from "@/v2-backoffice-client/components/button"
import Badge from "@/v2-backoffice-client/components/badge"
import type { CustomerFragment } from "@/v2-backoffice-client/customer/__types__/customer.fragment"
import MigrationCenterDialog from "@/v2-backoffice-client/tenant/migration/center/MigrationCenterDialog"

export type CustomerMigrateManyButtonProps = {
  customers: CustomerFragment[]
  onCompleted?(): void
}

// Opens the Migration Center for a customer-table selection (FUS-927):
// every team of every selected customer, grouped per customer, with live
// per-member status and the aggregate progress bar; the waves are sent
// from inside the dialog.
function CustomerMigrateManyButton(props: CustomerMigrateManyButtonProps) {
  const { customers, onCompleted } = props
  const [open, setOpen] = useState(false)
  const tenantCount = customers.reduce((sum, c) => sum + c.Tenants.length, 0)

  return (
    <>
      <TooltipButton
        className="relative"
        isStacked
        iconSrc="key"
        variant="ghost"
        content={`Review and send Fusion login activations for ${tenantCount} team(s) across ${customers.length} customer(s)`}
        disabled={!tenantCount}
        onClick={() => {
          setOpen(true)
        }}
      >
        Fusion
        <Badge
          className="absolute top-0 right-0 text-[8px] rounded-full"
          variant="neutral"
          size="tiny"
        >
          {tenantCount}
        </Badge>
      </TooltipButton>

      <MigrationCenterDialog
        open={open}
        onOpenChange={setOpen}
        selection={{ kind: "customers", customers }}
        onCompleted={onCompleted}
      />
    </>
  )
}

export default CustomerMigrateManyButton
